module.exports = {
  WinName: 'Chọn mẫu',
  TemplateName: 'Tên mẫu',
  OK: 'Xác nhận',
  Cancel: 'Hủy bỏ',
  QueryTemplateFailed: 'Truy vấn mẫu thất bại!',
  Tips: 'Nhắc nhở',
  PlsSelectTemplate: 'Vui lòng chọn một mẫu!',
  Copy: 'Sao chép',
  TemplateTypes: 'Loại mẫu',
  EmailTemp: 'Hiển thị mẫu email',
  viewV3: 'Hiển thị mẫu V3',
  inputTemplateName: 'Nhập tên mẫu',
  notFoundTemplate: 'Không tìm thấy mẫu tương ứng, vui lòng thêm mẫu trước!',
  batchPrintMore: 'Số lượng dữ liệu in hàng loạt vượt quá {0} (giới hạn hệ thống), hệ thống không thể tải, vui lòng liên hệ hỗ trợ trực tuyến!',
  noSchemaType: 'SchemaType chưa được bảo trì!',
  printMore: 'Số bản ghi in vượt quá 100, thời gian tải có thể lâu, bạn có muốn tiếp tục in?',
  notFoundTemplateFromData: 'Không tìm thấy mẫu 【{0}】, vui lòng kiểm tra mẫu!',
  notEmptyTemplateName: 'Tên mẫu không được để trống!',
  hasFoundTemplateName: 'Tên mẫu đã tồn tại!',
  attachmentLarge: 'Nội dung tệp đính kèm quá lớn!',
  smtpServerError: 'Lỗi máy chủ SMTP!',
  unConnectSmtp: 'Không thể kết nối đến máy chủ SMTP!',
  notFoundFile: 'Hệ thống không tìm thấy tệp được chỉ định!',
  fileSendError: 'Lỗi khi gửi tệp!',
  attachmentTemplateError: 'Lỗi mẫu đính kèm!',
  sendEmailSuccess: 'Gửi email thành công!'
}
